/*
*###############################################################################
*Module Name                   : ScaleDataPrintContent.js                      #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : Dinisuru Balasooriya                          #
*Date                          : Friday, February 02nd 2024, 9:18:43 Am        #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import DPDropDown from "framework/components/DPDropDown";
import DPTextBox from "framework/components/DPTextBox";
import React, { useEffect, useRef, useState } from "react"

import {
  Col,
  Row,
  Button,
  Table,
  Alert,
  Label
} from "reactstrap"
import { GetTxnDropdown } from "./TransactionGenerateTXNWithExcelController";

const TransactionExcelUploadContent = ({

  show,
  AlertMsg,
  AlertColor,
  ErrorMsg,
  inputref,
  setFile,
  locationList,
  selectedLocation,
  locationOnChange,
  setReferenceNoOnChange,
  referenceNo,
  referenceType,
  setReferenceTypeOnChange


}) => {

  const [transactionList, setTransactionList] = useState([])

  useEffect(async () => {

    const { success, data } = await GetTxnDropdown();
    setTransactionList(data)

  }, [])


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };



  return (
    <React.Fragment>
      <Row>
        {show ? (
          <Alert color={AlertColor} role="alert">
            {AlertMsg}
            <br />
            <small>{ErrorMsg}</small>
          </Alert>
        ) : null}
      </Row >
      <Row className="mt-3">
        <Col md={4}>
          <DPDropDown
            labelText={"Location"}
            optionGroup={locationList}
            selectedGroup={selectedLocation}
            onChange={locationOnChange}
          />

          <DPDropDown
            labelText={"Reference Type"}
            optionGroup={transactionList}
            selectedGroup={referenceType}
            onChange={setReferenceTypeOnChange}
          />

          <DPTextBox
            labelText={"Reference No"}
            placeholder={"Enter Reference No"}
            value={referenceNo}
            onChange={setReferenceNoOnChange}
          />

          <Row>
            <Label htmlFor="example-text-input" className="col-md-3 col-form-label-sm">
              Upload Excel File
            </Label>

            <div className="col-md-6"> {/* Adjust the width as needed */}
              <input type="file" ref={inputref} onChange={handleFileChange} className="form-control-file" />
            </div>
          </Row>
        </Col>
      </Row>

      <Row>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </Row>
    </React.Fragment >
  )
}
export default TransactionExcelUploadContent